module.exports = __webpack_public_path__ + "static/japan11-11bc7f13c17970c9f9d48e34befc2384.jpg";